export const NOT_STARTED = 0;
export const PLAYING = 1;
export const PAUSED = 2;
export const ROUND_WON = 3;
export const ROUND_LOST = 4;
export const GAME_OVER = 5;



//////////////////
// WEBPACK FOOTER
// ./lib/javascripts/stages.js
// module id = 0
// module chunks = 0